<template>
    <!-- Body: Body -->
    <div class="login-wrapper body d-flex p-0 p-xl-5">
        <div class=" d-flex align-items-center w-100">
            <div v-if="isLoading" class="loadingDiv d-flex flex-column align-items-center justify-content-center">
                <div class="text-center">
                    <div style="gap:30px" class="d-flex align-items-baseline">
                        <div>
                            <h3 class="text-dark">H εγγραφή είναι σε εξέλιξη</h3>
                        </div>
                        <div class="dot-flashing"></div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="row g-0 mt-xl-0 mt-5 mb-5 d-flex justify-content-center align-items-center">
                    <div class="col-lg-8  border-0 rounded-lg">
                        <div class="w-xl-50 w-100 card shadow-none  border-0 text-dark">
                            <!-- Form -->
                            <form class="row g-1 p-3 p-md-4" @submit.prevent="handleSubmit">

                                <div class="col-12 text-center mb-1 mb-lg-3">
                                    <h3><b>Εγγραφή νέου χρήστη</b></h3>
                                    <span>Εισάγετε τα στοιχεία του λογαριασμού σας.</span>
                                </div>

                                <div class="col-md-6 pe-3" v-if="form.usertype_id != ''">
                                    <div class="mb-2">
                                        <label class="form-label fw-bold">Όνομα</label>
                                        <input type="text" class="form-control form-control-md" placeholder="Όνομα"
                                            v-model="form.name">
                                    </div>
                                </div>

                                <div class="col-md-6" v-if="form.usertype_id != ''">
                                    <div class="mb-2">
                                        <label class="form-label fw-bold">Επώνυμο</label>
                                        <input type="text" class="form-control form-control-md" placeholder="Επώνυμο"
                                            v-model="form.surname">
                                    </div>
                                </div>

                                <div class="col-md-6 pe-3" v-if="form.usertype_id != ''">
                                    <div class="mb-2">
                                        <label class="form-label fw-bold">Διεύθυνση email</label>
                                        <input type="email" class="form-control form-control-md email"
                                            placeholder="name@example.com" v-model="form.email">
                                    </div>
                                </div>

                              
                                <div class="col-md-6 pe-3" v-if="form.usertype_id != ''">
                                    <div class="mb-2">
                                        <label class="form-label fw-bold">Κινητό</label>
                                        <input type="text" class="form-control form-control-md" placeholder="Κινητό"
                                            v-model="form.mobile" minlength="10">
                                    </div>
                                </div>
                               
                                <div class="col-md-6 pe-3" v-if="form.usertype_id != ''">
                                    <div class="mb-2">
                                        <div class="form-label">
                                            <span class="fw-bold d-flex justify-content-between align-items-center">
                                                Κωδικός πρόσβασης
                                            </span>
                                        </div>
                                        <div class="d-flex justify-content-center align-items-center position-relative">
                                            <input id="password" type="password" class="form-control form-control-md"
                                                v-model="form.password" placeholder="******">
                                            <span class="showPasswordIcon" @click="showPass()"><i class="icofont-eye-alt"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6" v-if="form.usertype_id != ''">
                                    <div class="mb-2">
                                        <div class="form-label">
                                            <span class="fw-bold d-flex justify-content-between align-items-center">
                                                Επιβεβαίωση κωδικού πρόσβασης
                                            </span>
                                        </div>
                                        <div class="d-flex justify-content-center align-items-center">
                                            <input id="password_confirmation" type="password"
                                                class="form-control form-control-md"
                                                v-model="form.password_confirmation" placeholder="******">
                                            <span class="showPasswordIcon" @click="showPassConfirm()"><i class="icofont-eye-alt"></i></span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 text-center mt-4" v-if="form.usertype_id != ''">
                                    <button type="submit"
                                        class="px-4 py-2 btn btn-block btn-light lift btn-register fs-5"><b>ΕΓΓΡΑΦΗ</b></button>
                                </div>
                                <div class="col-12 text-center mt-3">
                                    <a href="/" style="text-decoration: underline;color: gray; font-size: 12px;">Πίσω
                                        στην αρχική</a>
                                </div>

                            </form>
                            <!-- End Form -->
                        </div>
                    </div>
                </div> <!-- End Row -->
            </div>
            <div id="extra-content">
            </div>
        </div>
    </div>


</template>

<script>
import '../assets/js/bundles/libscripts.bundle.js';
import { ref, onMounted, onUnmounted } from 'vue';
import { register as Register } from '../services/auth.js';
import { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import router from '@/router';

export default {
    name: 'Register',
    setup() {
        const form = ref({
            name: '',
            surname: '',
            email: '',
            usertype_id: 2,
            address: '',
            mobile: '',
            password: '',
            password_confirmation: '',
            afm: '',
            brandname: '',
            zipcode: ''
        });

        const file = ref(null);

        const isLoading = ref(false);
        const errorMessage = ref('');
        const successMessage = ref('');

        const toast = useToast();

        const showPass = () => {
            const passField = document.getElementById('password');
            if (passField) {
            passField.type = passField.type === 'password' ? 'text' : 'password';
            }
        };

        const showPassConfirm = () => {
            const passField = document.getElementById('password_confirmation');
            if (passField) {
            passField.type = passField.type === 'password' ? 'text' : 'password';
            }
        };


        const handleSubmit = async () => {
            isLoading.value = true;
            try {
                const formData = new FormData();
                formData.append('email', form.value.email);
                formData.append('password', form.value.password);
                formData.append('password_confirmation', form.value.password_confirmation);
                formData.append('usertype_id', form.value.usertype_id);
                formData.append('address', form.value.address);
                formData.append('mobile', form.value.mobile);
                formData.append('afm', form.value.afm);
                formData.append('brandname', form.value.brandname);
                formData.append('zipcode', form.value.zipcode);
                formData.append('name', form.value.name);
                formData.append('surname', form.value.surname);
                const response = await Register(formData);
                if (response.data?.success) {
                    const token = response.data?.data?.token?.plainTextToken;
                     window.dispatchEvent(new Event('auth-changed'));
                    if (token) localStorage.setItem('api_token', token);
                    router.push('/');
                } else {
                    errorMessage.value = response.data.message;
                    toast.error(response.data.message);
                }
            } catch (error) {
                console.error('Registration error:', error);
                errorMessage.value = 'An error occurred while registering. Please try again later.';
                toast.error('An error occurred while registering. Please try again later.');
            } finally {
                isLoading.value = false;
            }
        };


        const handleKeyPressed = (event) => {
            if (event.key == 'Enter') {
                document.querySelector('.btn-register').click();
            }
        };

        onMounted(() => {
            document.addEventListener('keyup', handleKeyPressed);
        });

        onUnmounted(() => {
            document.removeEventListener('keyup', handleKeyPressed);
        });

        return {
            form,
            isLoading,
            errorMessage,
            successMessage,
            handleSubmit,
            showPass,
            showPassConfirm
        };
    }
};
</script>

<style>
/* Styles specific to login view */
.option-box{
    border: 1px solid var(--primary-color) !important;
    cursor: pointer;
    transition: 1s;
}
.option-box:hover{
    background-color: var(--primary-color);
    color: white !important;
    transition: 1s;
}
.option-box.selected{
    background-color: var(--primary-color);
    color: white !important;
}
.showPasswordIcon {

    font-size: large;
    position: absolute;
    right: 16%;
  }
</style>
